import React from "react";

import GHAR from "assets/img/ghar.png";
import CAKE from "assets/img/cake.png";
import RONB from "assets/img/ronb.png";
import YAXIS from "assets/img/yaxis.png";
import COFFEE from "assets/img/coffee.png";
import BARISTA from "assets/img/barista.png";

import "./brand-section.styles.scss";

const BrandSection = () => {
  return (
    <div className="brand-section">
      <div className="container">
        <span>Multiple brands. Dynamic work. One fervent spirit.</span>
        <h1>Brands we worked with</h1>
        <div className="mt-5 d-flex justify-content-between flex-wrap">
          <img src={RONB} alt="ronb"></img>
          <img src={GHAR} alt="ghar"></img>
          <img src={COFFEE} alt="ronb"></img>
          <img src={BARISTA} alt="ronb"></img>
          <img src={YAXIS} alt="ghar"></img>
          <img src={CAKE} alt="ghar"></img>
        </div>
      </div>
    </div>
  );
};

export default BrandSection;
